var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notFound)?_c('not-found-content'):(_vm.page)?_c('div',{staticClass:"page-content"},_vm._l((_vm.page.blocks),function(block,index){return _c(block.template,_vm._b({key:'block-' + block.id,tag:"component"},'component',block,false))}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }